module.exports = __webpack_public_path__ + "img/putevki.76de02bc.svg";